// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/assay_lot_data.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/assay_lot_data.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_assay_lot_data: GenFile = /*@__PURE__*/
  fileDesc("CjxxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYXNzYXlfbG90X2RhdGEucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSJOCgxBc3NheUxvdERhdGESDwoCaWQYASABKAlIAIgBARIXCgpsb3RfbnVtYmVyGAIgASgJSAGIAQFCBQoDX2lkQg0KC19sb3RfbnVtYmVyYgZwcm90bzM");

/**
 * Contains lot-specific assay data.
 * As of 2025-04-16 the contents of this data type are under-defined,
 * this message is introduced as a placeholder and expected to change
 * (possibly substantially)
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AssayLotData
 */
export type AssayLotData = Message<"quanterix.simoa_one.analysis_app_api.v1.AssayLotData"> & {
  /**
   * Unique identifier (UUID)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Lot number identifier
   * Note: unclear whether this is the appropriate type (Changed from int32 to string per SFSE-3252)
   *
   * @generated from field: optional string lot_number = 2;
   */
  lotNumber?: string;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AssayLotData.
 * Use `create(AssayLotDataSchema)` to create a new message.
 */
export const AssayLotDataSchema: GenMessage<AssayLotData> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_assay_lot_data, 0);

